import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
import i18next from 'i18next'
import { urlWithQuery } from '../../utils/uriUtils'
import { getProjects } from '../../services/projectsService'

// Connects to data-controller="contacts--index"
export default class extends Controller {
  static targets = ['projectId', 'roleCode', 'organizationId']
  static values = {
    currentUserAgencyId: String,
    projectId: String,
  }

  connect() {
    this.initProjectSelect()
    this.initRoleCodeSelect()
    this.initOrganizationSelect()
    // this.updateSelects()
  }

  disconnect() {
    this.projectSelect.destroy()
    this.roleCodeSelect.destroy()
    this.organizationSelect.destroy()
  }

  initOrganizationSelect() {
    this.organizationSelect = new TomSelect(
      this.organizationIdTarget,
      {
        placeholder: i18next.t('attributes.organization.title_placeholder'),
        plugins: ['remove_button'],
        selectOnTab: true,
        valueField: 'id',
        labelField: 'name',
        searchField: 'name',
        closeAfterSelect: true,
        onChange: () => {
          // this.updateSelects()
          this.updateFilters()
        },
      },
    )
  }

  // updateSelects() {
  //   const selectedOrganizationId = this.organizationSelect.getValue()
  //   if (selectedOrganizationId && selectedOrganizationId !== this.currentUserAgencyIdValue) {
  //     this.projectSelect.clear()
  //     this.projectSelect.clearOptions()
  //   }
  // }

  initProjectSelect() {
    this.projectSelect = new TomSelect(this.projectIdTarget, {
      valueField: 'id',
      labelField: 'title',
      searchField: 'title',
      plugins: ['remove_button'],
      preload: true,
      create: false,
      load: async (search, callback) => {
        const data = await getProjects(search)
        callback([{ id: '', title: i18next.t('attributes.project.title_placeholder'), total: 0 }, ...data.projects])
      },
      onChange: this.updateFilters.bind(this),
    })
  }

  initRoleCodeSelect() {
    this.roleCodeSelect = new TomSelect(
      this.roleCodeTarget,
      {
        placeholder: i18next.t('attributes.roles.title_placeholder'),
        plugins: ['remove_button'],
        selectOnTab: true,
        valueField: 'id',
        labelField: 'name',
        closeAfterSelect: true,
        onChange: this.updateFilters.bind(this),
      },
    )
  }

  updateFilters() {
    const params = {
      project_id: this.projectSelect.getValue(),
      role_codes: this.roleCodeSelect.getValue(),
      organization_id: this.organizationSelect.getValue(),
    }

    const url = urlWithQuery(
      this.contactsUrl(params),
      {
        role_codes: params.role_codes.length > 0 ? params.role_codes.join(',') : undefined,
      },
    )
    window.location.href = url
  }

  contactsUrl(params) {
    if (params.project_id && params.organization_id) {
      return `/organizations/${params.organization_id}/projects/${params.project_id}/contacts`
    } else if (params.project_id) {
      return `/projects/${params.project_id}/contacts`
    } else if (params.organization_id) {
      return `/organizations/${params.organization_id}/contacts`
    }
    return '/contacts'
  }
}
